(function() {
  const root = document.querySelector('.cart-cfg');
  if (!root) return;

  const animEls = root.querySelectorAll('.cart-cfg-anim');
  if (animEls.length > 0 && typeof IntersectionObserver !== 'undefined') {
    const animIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('cart-cfg-visible');
          animIo.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    animEls.forEach(function(el) { animIo.observe(el); });

    setTimeout(function() {
      animEls.forEach(function(el) {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          el.classList.add('cart-cfg-visible');
        }
      });
    }, 800);
  } else {
    animEls.forEach(function(el) { el.classList.add('cart-cfg-visible'); });
  }

  const state = {
    show_cart_announcement: true,
    cart_announcement_text: 'Your cart is reserved for {timer} minutes! Checkout before items sell out.',
    show_cart_timer: true,
    cart_timer_minutes: 10,
    timer_bg_color: '#E8F7F7',
    show_free_shipping_bar: true,
    free_shipping_threshold: 200,
    show_discount_milestone: false,
    discount_threshold: 300,
    discount_label: '5% Off',
    show_cart_upsells: true,
    upsell_title: "You'll love these",
    show_gift_wrap: true,
    gift_wrap_title: 'Add gift wrapping',
    show_gift_note: true,
    gift_note_title: 'Add a gift message',
    show_addon_1: true,
    addon_1_title: 'Unlimited Next Day Delivery',
    addon_1_description: 'Get unlimited next day delivery for just £9.99 a year. Minimum £20 spend per order applies.',
    addon_1_price: '9.99',
    addon_1_most_popular: false,
    show_addon_2: true,
    addon_2_title: 'Warranty Upgrade + Unlimited Next Day Delivery',
    addon_2_description: 'Next-day replacement — no waiting 14 days for manufacturer claims. Includes unlimited next day delivery all year.',
    addon_2_price: '19.99',
    addon_2_most_popular: true,
    upsell_primary_color: '#F35D9C',
    cart_total: 104.80
  };

  function hexToRgba(hex, alpha) {
    const h = hex.replace('#', '');
    if (h.length !== 6) return hex;
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  }

  function pad(n) { return n.toString().padStart(2, '0'); }

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return root.querySelectorAll(sel); }

  function render() {
    root.style.setProperty('--cart-cfg-brand', state.upsell_primary_color);
    root.style.setProperty('--cart-cfg-brand-soft', hexToRgba(state.upsell_primary_color, 0.08));
    root.style.setProperty('--cart-cfg-timer-bg', hexToRgba(state.timer_bg_color, 0.12));

    const banner = $('#cartCfgBanner');
    if (state.show_cart_announcement) {
      banner.classList.remove('is-hidden');
      const bannerText = $('#cartCfgBannerText');
      let html = state.cart_announcement_text;
      if (state.show_cart_timer) {
        html = html.replace('{timer}', '<b>' + pad(state.cart_timer_minutes) + ':00</b>');
      } else {
        html = html.replace('{timer}', '');
      }
      bannerText.innerHTML = html;
    } else {
      banner.classList.add('is-hidden');
    }

    const progress = $('#cartCfgProgress');
    if (state.show_free_shipping_bar) {
      progress.classList.remove('is-hidden');

      const cart = state.cart_total;
      const fst = state.free_shipping_threshold;
      const dt = state.discount_threshold;
      const showDiscount = state.show_discount_milestone;

      const fsUnlocked = cart >= fst;
      const dUnlocked = cart >= dt;

      let pct;
      if (showDiscount) {
        if (cart >= dt) {
          pct = 100;
        } else if (cart >= fst) {
          pct = 50 + ((cart - fst) / (dt - fst)) * 50;
        } else {
          pct = (cart / fst) * 50;
        }
      } else {
        pct = Math.min(100, (cart / fst) * 100);
      }

      $('#cartCfgProgressBar').style.width = pct + '%';

      const m1 = $('#cartCfgMilestone1');
      const m1Lbl = $('#cartCfgMilestone1Lbl');
      const barWrap = progress.querySelector('.cart-cfg__d-bar');

      m1.style.left = showDiscount ? '50%' : '100%';
      m1Lbl.style.left = showDiscount ? '50%' : '100%';
      m1Lbl.textContent = 'Free Shipping';
      m1Lbl.style.transform = showDiscount ? 'translateX(-50%)' : 'translateX(-100%)';
      m1.classList.toggle('is-done', fsUnlocked);

      let m2 = $('#cartCfgMilestone2');
      let m2Lbl = $('#cartCfgMilestone2Lbl');

      if (showDiscount) {
        if (!m2) {
          m2 = document.createElement('div');
          m2.id = 'cartCfgMilestone2';
          m2.className = 'cart-cfg__d-milestone';
          m2.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"/><circle cx="6.75" cy="6.75" r="1" fill="currentColor"/></svg>';
          barWrap.appendChild(m2);

          m2Lbl = document.createElement('div');
          m2Lbl.id = 'cartCfgMilestone2Lbl';
          m2Lbl.className = 'cart-cfg__d-milestone-label';
          barWrap.appendChild(m2Lbl);
        }
        m2.style.left = '100%';
        m2Lbl.style.left = '100%';
        m2Lbl.style.transform = 'translateX(-100%)';
        m2.classList.toggle('is-done', dUnlocked);
        m2Lbl.textContent = state.discount_label || '5% Off';
      } else {
        if (m2) m2.remove();
        if (m2Lbl) m2Lbl.remove();
      }

      const remainingFs = Math.max(0, fst - cart);
      const remainingD = Math.max(0, dt - cart);
      const msg = $('#cartCfgProgressMsg');
      if (showDiscount) {
        if (fsUnlocked && dUnlocked) {
          msg.innerHTML = "🎉 You've unlocked <b>FREE shipping</b> and <b>" + state.discount_label + "</b>!";
        } else if (fsUnlocked) {
          msg.innerHTML = "🎉 FREE shipping unlocked! You're <b>£" + remainingD.toFixed(0) + "</b> from <b>" + state.discount_label + "</b>";
        } else if (dUnlocked) {
          msg.innerHTML = "🎉 <b>" + state.discount_label + "</b> unlocked! You're <b>£" + remainingFs.toFixed(0) + "</b> from free shipping";
        } else {
          msg.innerHTML = "You're <b>£" + remainingFs.toFixed(0) + "</b> from free shipping";
        }
      } else {
        if (fsUnlocked) {
          msg.innerHTML = "🎉 You've unlocked <b>FREE shipping</b>!";
        } else {
          msg.innerHTML = "You're <b>£" + remainingFs.toFixed(0) + "</b> from free shipping";
        }
      }
    } else {
      progress.classList.add('is-hidden');
    }

    const upsells = $('#cartCfgUpsells');
    if (state.show_cart_upsells) {
      upsells.classList.remove('is-hidden');
      $('#cartCfgUpsellTitle').textContent = state.upsell_title;
    } else {
      upsells.classList.add('is-hidden');
    }

    const giftwrap = $('#cartCfgGiftwrap');
    if (state.show_gift_wrap) {
      giftwrap.classList.remove('is-hidden');
      $('#cartCfgGiftwrapTitle').textContent = state.gift_wrap_title;
      const giftnote = $('#cartCfgGiftnote');
      if (state.show_gift_note) {
        giftnote.style.display = '';
        giftnote.textContent = state.gift_note_title;
      } else {
        giftnote.style.display = 'none';
      }
    } else {
      giftwrap.classList.add('is-hidden');
    }

    const addon1 = $('#cartCfgAddon1');
    if (state.show_addon_1) {
      addon1.classList.remove('is-hidden');
      $('#cartCfgAddon1Title').textContent = state.addon_1_title;
      $('#cartCfgAddon1Desc').textContent = state.addon_1_description;
      const p1 = parseFloat(state.addon_1_price);
      $('#cartCfgAddon1Price').textContent = isNaN(p1) ? '' : '- £' + p1.toFixed(2);
      addon1.classList.toggle('is-popular', !!state.addon_1_most_popular);
    } else {
      addon1.classList.add('is-hidden');
    }

    const addon2 = $('#cartCfgAddon2');
    if (state.show_addon_2) {
      addon2.classList.remove('is-hidden');
      $('#cartCfgAddon2Title').textContent = state.addon_2_title;
      $('#cartCfgAddon2Desc').textContent = state.addon_2_description;
      const p2 = parseFloat(state.addon_2_price);
      $('#cartCfgAddon2Price').textContent = isNaN(p2) ? '' : '- £' + p2.toFixed(2);
      addon2.classList.toggle('is-popular', !!state.addon_2_most_popular);
    } else {
      addon2.classList.add('is-hidden');
    }

    $$('[data-swatches]').forEach(group => {
      const key = group.dataset.swatches;
      const val = state[key];
      group.querySelectorAll('.cart-cfg__sw').forEach(sw => {
        sw.classList.toggle('is-on', sw.dataset.color && sw.dataset.color.toLowerCase() === (val || '').toLowerCase());
      });
    });

    $$('[data-color-pip]').forEach(pip => {
      const key = pip.dataset.colorPip;
      pip.style.background = state[key];
    });
    $$('[data-color-input]').forEach(input => {
      const key = input.dataset.colorInput;
      if (document.activeElement !== input) input.value = (state[key] || '').toUpperCase();
    });
  }

  $$('[data-toggle]').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const key = toggle.dataset.toggle;
      const isOn = toggle.classList.toggle('is-on');
      state[key] = isOn;
      render();
    });
  });

  $$('[data-input]').forEach(input => {
    input.addEventListener('input', () => {
      const key = input.dataset.input;
      state[key] = input.value;
      render();
    });
  });

  $$('[data-slider]').forEach(slider => {
    const key = slider.dataset.slider;
    const min = parseInt(slider.dataset.min);
    const max = parseInt(slider.dataset.max);
    const fill = slider.querySelector('.cart-cfg__slider-fill');
    const knob = slider.querySelector('.cart-cfg__slider-knob');
    const valEl = root.querySelector('[data-slider-val="' + key + '"]');

    function setFromValue(val) {
      val = Math.max(min, Math.min(max, val));
      state[key] = val;
      const pct = ((val - min) / (max - min)) * 100;
      fill.style.width = pct + '%';
      knob.style.left = pct + '%';
      if (valEl) valEl.value = val;
      render();
    }

    function setFromX(clientX) {
      const rect = slider.getBoundingClientRect();
      const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      const raw = min + pct * (max - min);
      const step = (max - min) >= 100 ? 10 : 1;
      const val = Math.round(raw / step) * step;
      setFromValue(val);
    }

    let dragging = false;
    slider.addEventListener('mousedown', e => {
      dragging = true;
      setFromX(e.clientX);
      e.preventDefault();
    });
    document.addEventListener('mousemove', e => { if (dragging) setFromX(e.clientX); });
    document.addEventListener('mouseup', () => { dragging = false; });
    slider.addEventListener('touchstart', e => {
      dragging = true;
      setFromX(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchmove', e => {
      if (dragging) setFromX(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchend', () => { dragging = false; });
  });

  $$('.cart-cfg__sw[data-color]').forEach(sw => {
    sw.addEventListener('click', () => {
      const group = sw.closest('[data-swatches]');
      const key = group.dataset.swatches;
      state[key] = sw.dataset.color;
      render();
    });
  });

  $$('[data-color-input]').forEach(input => {
    input.addEventListener('input', () => {
      const key = input.dataset.colorInput;
      let val = input.value.trim();
      if (!val.startsWith('#')) val = '#' + val;
      if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
        state[key] = val;
        render();
      }
    });
  });

  const grid = $('#cartCfgGrid');
  const seeLiveBtn = $('#cartCfgSeeLive');

  if (seeLiveBtn && grid) {
    seeLiveBtn.addEventListener('click', () => {
      const isPreview = grid.classList.toggle('is-preview');
      seeLiveBtn.classList.toggle('is-back', isPreview);
      if (isPreview) {
        const drawer = $('#cartCfgDrawer');
        if (drawer) drawer.scrollTop = 0;
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  render();
})();

(function() {
  var sections = document.querySelectorAll('.cart-cfg');
  if (!sections.length) return;

  var headerHideObserver = new IntersectionObserver(function(entries) {
    var anyVisible = entries.some(function(e) { return e.isIntersecting; });
    if (anyVisible) {
      document.body.classList.add('cart-cfg-section-active');
    } else {
      var stillVisible = false;
      sections.forEach(function(el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.5 && r.bottom > 80) {
          stillVisible = true;
        }
      });
      if (!stillVisible) {
        document.body.classList.remove('cart-cfg-section-active');
      }
    }
  }, { threshold: 0, rootMargin: '-80px 0px -50% 0px' });

  sections.forEach(function(sec) { headerHideObserver.observe(sec); });
})();